enum StorageKey {
	IDENTIFIANT_EXERCICE = 'comptabilite.identifiantExercice',
	IDENTIFIANT_ENTITE = 'comptabilite.identifiantEntite',
}

export default StorageKey;
